
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// validation
import useVuelidate from '@vuelidate/core'

// composable
import { required } from '@vuelidate/validators'

// types
import { CarrierT } from '@/core/types/carriers.types'

// classes
import { DataState } from '@/core/classes/DataState.class'
import { carriers } from '@/core/realisations/carriers.realisation'

export default defineComponent({
    components: {
        modal: Modal,
        TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            //
            companyId: null as number | null,
        })

        const ChangeCompanyRPPValidation = {
            companyId: { required },
        }

        const state_form$ = useVuelidate(ChangeCompanyRPPValidation, state)

        const data_state = reactive(new DataState<CarrierT>({}))

        //

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmit = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', state.companyId)
        }

        //

        const loadCompanies = async (page: number, search?: string) => {
            data_state.pagination.current_page = page

            try {
                data_state.is_loading = true

                const params = {
                    page,
                    search,
                    getAllCarriers: 1,
                    limit: 9999,
                    statusId: 2,
                }

                const response = await carriers.getList(params)
                data_state.list = response.data

                data_state.pagination.total_pages = response.meta.last_page

                data_state.is_failed = false
                data_state.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.failure.catchError(error)

                if (!data_state.failure.error_state.is_cancel) {
                    data_state.is_failed = true
                }
            } finally {
                data_state.is_loading = false
            }
        }

        const searchCompanies = (search_query: string) => {
            loadCompanies(1, search_query)
        }

        const unshiftFoundCompany = async (company: CarrierT) => {
            await loadCompanies(data_state.pagination.current_page)
            data_state.list.unshift(company)
        }

        //

        const isLoading = computed(() => state.is_loading || data_state.is_loading || props.loading)

        //

        onBeforeMount(() => loadCompanies(1))

        return {
            state,
            state_form$,
            data_state,
            //
            emitCancel,
            emitSubmit,
            //
            loadCompanies,
            searchCompanies,
            unshiftFoundCompany,
            //
            isLoading,
        }
    },
})
